// state
export const MODULE_ID = 'moduleId'
// mutations.js
export const SET_VALUE = 'setValue'
